import { render, staticRenderFns } from "./ReturnAccept.vue?vue&type=template&id=5a866e40&"
import script from "./ReturnAccept.vue?vue&type=script&lang=js&"
export * from "./ReturnAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports